export const environment = {
  production: false,
  // Modern Mode See https://cli.vuejs.org/guide/browser-compatibility.html#modern-mode
  VUE_CLI_MODERN_MODE: true,
  VUE_CLI_MODERN_BUILD: true,
  VUE_APP_ACCESS_ROLE: 'PATIENT',
  VUE_APP_DENIED_ROLE_REDIRECT: 'https://stage-anywhere.careclix.com/sso-auth',

  // Build Environment
  NODE_ENV: 'production',
  // VUE_APP_BUILD_ID: 1,

  // Default Phone Number
  VUE_APP_MAIN_PHONE: '855-227-3259',

  // Firebase Messaging
  VUE_APP_FIREBASE_API_KEY: 'AIzaSyBY_liC4IPxd_rd9xoBaqjLtz4QbSN9TOk',
  VUE_APP_FIREBASE_AUTH_DOMAIN: 'careclix-pre-production.firebaseapp.com',
  VUE_APP_FIREBASE_DATABASE_URL: 'https://careclix-pre-production.firebaseio.com',
  VUE_APP_FIREBASE_PROJECT_ID: 'careclix-pre-production',
  VUE_APP_FIREBASE_STORAGE_BUCKET: 'careclix-pre-production.appspot.com',
  VUE_APP_FIREBASE_MESSAGING_SENDER_ID: '833415808476',
  VUE_APP_FIREBASE_APP_ID: '1:833415808476:web:9c2435bbeab5d149c27b19',
  VUE_APP_FIREBASE_MEASUREMENT_ID: 'G-MW7ELTZNT0',

  // Google? Seems to be hardcoded? Not sure if used.
  VUE_APP_GOOGLE_CLOUD_HOST: 'https://storage.googleapis.com/storage_micro_files/',
  VUE_APP_GOOGLE_MAPS_KEY: 'AIzaSyAx5vxOMwxfXivvTBgJN9TAacJEEZXJlj4',

  // Recaptcha
  VUE_APP_RECAPTCHA_SITE_KEY: '6LeoX8crAAAAAP1YmeD2N_9mbGTd9L9gbVe5ajrt',

  // MapBox
  VUE_APP_MAP_BOX_KEY:
    'pk.eyJ1IjoidmxhZGltaXJzaGtyb2JvdCIsImEiOiJjazk0OTJodDkwM2IwM2duM2VlN2lzMzRpIn0.X2r4dS-W4er8t8iC08aTJQ',

  // Pillar Payment
  VUE_APP_PILLAR_COLLECT_KEY: '64Q6tB-a3PH66-p8sZ83-E96pj6',

  // LogRocket Configuration Production
  // VUE_APP_LOG_ROCKET_APP_ID: 'utr26e/careclix',
  // VUE_APP_LOG_ROCKET_SANITIZE_INPUT: true,
  // VUE_APP_LOG_ROCKET_SANITIZE_TEXT: true,

  // Bugsnag
  VUE_APP_BUGSNAG_API_KEY: '2c3a8e6e936ffebb82643caa196b15eb',

  // Demo E-prescribe account
  // VUE_APP_EAZY_SCRIPTS_SUB_DOMAIN: 'demo-careclix',
  // VUE_APP_EAZY_SCRIPTS_PREFIX: 'demo-app',
  // VUE_APP_EAZY_SCRIPTS_KEY: '8e20169c-742b-4f14-9a53-44309b4316d1',
  // VUE_APP_EAZY_SCRIPTS_SECRET: '19-d2979bf4-9085-49e4-9169-9f5d87429cc6',

  // Prod E-prescribe account
  VUE_APP_EAZY_SCRIPTS_SUB_DOMAIN: 'careclix',
  VUE_APP_EAZY_SCRIPTS_PREFIX: 'careclix',
  VUE_APP_EAZY_SCRIPTS_KEY: '9dd94893-6bfb-4161-ad21-8b0b5d7548e5',
  VUE_APP_EAZY_SCRIPTS_SECRET: '13-9e2132dd-b843-4eb6-b838-2d63b320fb45',

  // Feature instance
  // VUE_APP_BACKEND_HOST: 'https://blue-careclix-api.technorely.com',
  // VUE_APP_WEBRTC_URL: 'https://blue-careclix-api.technorely.com',
  // VUE_APP_MEDIA_SOUP: 'https://blue-careclix-webrtc.technorely.com',
  // VUE_APP_INVITEE_VALIDATION_URL: 'https://blue-careclix-api.technorely.com/invitee',
  // VUE_APP_INVITEE_REDIRECT_URL: 'https://blue-careclix-api.technorely.com/invitee',

  // Prod CloudFront
  // VUE_APP_BACKEND_HOST: 'https://anywhere-api.careclix.com',
  // VUE_APP_WEBRTC_URL: 'https://anywhere-api.careclix.com',
  // VUE_APP_MEDIA_SOUP: 'https://anywhere-api-webrtc.careclix.com',
  // VUE_APP_INVITEE_VALIDATION_URL: 'https://stage-anywhere.careclix.com/invitee',
  // VUE_APP_INVITEE_REDIRECT_URL: 'https://stage-anywhere.careclix.com/invitee',

  // Stage
  // VUE_APP_BACKEND_HOST: 'https://stage-anywhere-api.careclix.com',
  // VUE_APP_WEBRTC_URL: 'https://stage-anywhere-api.careclix.com/',
  // VUE_APP_MEDIA_SOUP: 'https://stage-anywhere-webrtc.careclix.com',
  // VUE_APP_INVITEE_VALIDATION_URL: 'https://stage-anywhere.careclix.com/invitee',
  // VUE_APP_INVITEE_REDIRECT_URL: 'https://stage-anywhere.careclix.com/invitee',

  // Dev
  VUE_APP_BACKEND_HOST: 'https://api-dev.mycompassionmd.com',
  VUE_APP_WEBRTC_URL: 'https://api-dev.mycompassionmd.com',
  VUE_APP_INVITEE_VALIDATION_URL: 'https://dev.mycompassionmd.com/invitee',
  VUE_APP_INVITEE_REDIRECT_URL: 'https://dev.mycompassionmd.com/invitee',
  VUE_APP_MEDIA_SOUP: 'https://webrtc-dev.mycompassionmd.com',

  // CYPRESS
  // CYPRESS_BASE_URL: 'http://localhost:1024',
  CYPRESS_BASE_URL: 'https://dev.mycompassionmd.com',
  // CYPRESS_RECORD_KEY: "6e5c2ebf-48e3-40c8-8e48-60d0d6143594",
  CYPRESS_CLINIC_STRIPE: 'testcy',
  CYPRESS_CLINIC_PILLAR: 'timonpillar',
  CYPRESS_USERNAME_SUPER_ADMIN: 'superadmincy',
  CYPRESS_USERNAME_CLINIC_ADMIN: 'clinicadmincy',
  CYPRESS_USERNAME_PROVIDER1: 'providercy',
  CYPRESS_USERNAME_PATIENT1: 'patientcy',
  CYPRESS_USERNAME_PATIENT_PILLAR: 'timapatientpillar',
  CYPRESS_COMMON_PASSWORD: 'Test2026!',
  CYPRESS_USE_PILLAR: true,

  // Sentry
  VUE_APP_SENTRY_DSN:
    'https://4bd2d242b57f54b73a67002679cd612d@o4510827063017472.ingest.us.sentry.io/4511750682378240',
  VUE_APP_SENTRY_ENV: 'development',

  // PostAffiliatePro | Sideqik
  VUE_APP_AFFILIATE_PROGRAM: 'PostAffiliatePro',

  // Sideqik pixel
  VUE_APP_SIDEQIK_LINK: 'https://d1hrk5gt3yn7pi.cloudfront.net/api/sideqik-api-1.4.js',
  VUE_APP_SIDEQIK_HASH: '648d14a1799b350045f2305e',

  // Post Affiliate Pro
  VUE_APP_POST_AFFILIATE_PRO_DOMAIN: 'myguardiandoc.postaffiliatepro.com',
};
